import { render, staticRenderFns } from "./t-termianl.vue?vue&type=template&id=60a4f4fd&"
import script from "./t-termianl.vue?vue&type=script&lang=js&"
export * from "./t-termianl.vue?vue&type=script&lang=js&"
import style0 from "./t-termianl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports